module.exports = __webpack_public_path__ + "img/mingjue-helen-chen-parkillo.5b11797.jpg";